import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

function About() {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: '100vh', // acoperă tot viewport-ul
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(-45deg, #1976d2, #1565c0, #0d47a1, #42a5f5)',
        backgroundSize: '400% 400%',
        animation: 'gradientAnimation 15s ease infinite',
        color: '#fff',
        textAlign: 'center',
        padding: 3,
        '@keyframes gradientAnimation': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
      }}
    >
      <Typography
        component={motion.h1}
        variant={isSmall ? 'h4' : 'h2'}
        fontWeight="bold"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        sx={{
          background: 'linear-gradient(to right, #ffffff, #bbdefb)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          mb: 2,
        }}
      >
        {t('about.title')}
      </Typography>

      <Typography
        component={motion.p}
        variant="h6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        sx={{
          maxWidth: '700px',
          fontFamily: "'Courier New', Courier, monospace",
          fontSize: isSmall ? '1rem' : '1.25rem',
          color: '#e3f2fd',
        }}
      >
        {t('about.description')}
      </Typography>
    </Box>
  );
}

export default About;
